/*
 * @Author: wanglibo
 * @LastEditors: wanglibo
 * @Description: 
 */
import Vue from 'vue';
import App from './App.vue';
import router from './router/index';
import GoEasy from 'goeasy'
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.config.productionTip = false;

Vue.prototype.globalData = {
    currentUser: null,
    
};

new Vue({
    router,
    render: (h) => h(App),
}).$mount('#app');

const goEasy = GoEasy.getInstance({
    host: 'hangzhou.goeasy.io', //应用所在的区域地址: 【hangzhou.goeasy.io |singapore.goeasy.io】
    appkey: 'BC-8c7364cfbc9a4cfab20564cdddb9456d', // common key,
    modules: ['im','pubsub'],
});

Vue.prototype.GoEasy = GoEasy;
Vue.prototype.goEasy = goEasy;
Vue.use(Vant);


